import React from 'react';
import API from "../../Services/BaseService";
import { useSelector } from 'react-redux';
import Popup from '../../Component/Popup/Popup';
import { useForm } from "react-hook-form";
import { useState } from 'react';
import { useHistory } from "react-router-dom";
import checkImg from '../../../src/assets/img/check.svg';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import PageNotFound from '../FallBackUI/PageNotFound';
import '../ContactUs/ContactUs.css'
import { Modal, Button } from 'react-bootstrap';
import   '../ContactUs/ContactUs.css';

const DashBoardContactus = () => {

  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  }
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMsg, setPopupMsg] = useState("");
  const sellerDetails = useSelector(state => state.LoginReducer.payload);
  const [popupType, setPopupType] = useState("");
  const [popupActionType, setPopupActionType] = useState("");
  const [popupActionValue, setPopupActionValue] = useState("");
  const [popupActionPath, setPopupActionPath] = useState("");
  const [name, setName] = useState("");
  const [email, setEmailId] = useState("");
  const [comments, setComments] = useState("");
  // const [ename,seteName]=useState ("");
  // const [eemail,seteEmailId]=useState ("");
  // const [ecomments,seteComments]=useState ("");
  const [fullNameError, setFullNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [commentsError, setCommentsError] = useState("");

  const history = useHistory();
  const { register, handleSubmit, formState: { errors } } = useForm();

  const [dashErrors, setDashErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  function clear() {
    setName("")
    setEmailId("")
    setComments("")
    togglePopup();
  }

  const EmailSubmit = (data) => {
    setFullNameError("")
    setEmailError("")
    setCommentsError("")

    let request = {
      name,
      email,
      comments,
      //   seller_id:sellerDetails.seller_id,
      //   seller_token:sellerDetails.seller_token ,     
    };
    if (!name) {
      setFullNameError("Full Name is required")
      return;
    }
    else if (name.length > 50) {
      setFullNameError("Full Name must not exceed 50 characters")
      return;
    }

    else if (!email) {
      setEmailError("Email  is required")
      return;
    }
    else if (email && !new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i).test(email)) {
      setEmailError("Email  Must match the format")
      return;
    }
    else if (!comments) {
      setCommentsError("Comments is required")
      return;
    }
    else if (comments.length > 250) {
      setCommentsError("Comments must not exceed 250 characters")
      return;
    }

    // if(name!=="" && email!=="" && comments!==""){
    API.post("sellercontactUs/condition", request)
      .then((response) => {
        console.log("=========>", response);
        if (response.data.success) {
          console.log("==sss=>", response.data);
          const { data } = response;
          togglePopup()
          setPopupTitle("Enquiry Form");
          setPopupMsg("Mail sent successfully.Thank you So much for your business");
          setPopupType("success");
          setPopupActionType("close");
          setPopupActionValue("close");
          // setPopupActionPath("/contactus")
        } else {
          console.log("==sss1111=>", response.data);
          const { data } = response;
          togglePopup()
          setPopupTitle("Enquiry Form");
          setPopupMsg(data.error.err);
          // setPopupMsg("Floor is not Created, Please try Again");
          setPopupType("error");
          setPopupActionType("close");
          setPopupActionValue("close");
        }
      }, (error) => {
        togglePopup()
        setPopupTitle("Error");
        setPopupMsg("Something went wrong, Please try Again");
        setPopupType("error");
        setPopupActionType("close");
        setPopupActionValue("close");
      })
      .catch(function (error) {
        if (error.response) {
          setDashErrors(error.response.data.error)
          setErrorFlag(true)

        }
      });

  }

  const handleModalClose = () => {
    setName("")
    setEmailId("")
    setComments("")
    setIsOpen(false);
  };
  return (
    <div>
      <main id="main" className="inner-page">

        {errorFlag === true ? <PageNotFound error={dashErrors} /> :
          <div id="contact" className="contact">
            <div className="container" >
              <div className="contactblock col-lg-12">
                <div className="section-title">
                  <h2>Contact US</h2>
                </div>
                <div className="row content">

                  <div className="col-lg-6 d-flex align-items-stretch">
                    <div className="info">
                      <p className="contacttag">Here is our address , For more details please reach out. Also you can share your questions or concerns by submitting the Enquiry form. </p>
                      <div className="address">
                        <i className="icofont-google-map"></i>
                        <h4>Address</h4>
                        {/* <p>Fairview Ave, El Monte,USA, 91732</p> */}
                        <p>8251 S Harlem Ave Bridgeview, IL 60455.</p>
                      </div>
                      <div className="phone">
                        <i className="icofont-phone"></i>
                        <h4>Contact</h4>
                        <p>CALL US: +1(708)777-2277</p>
                      </div>

                      <div className="email">
                        <i className="icofont-envelope"></i>
                        <h4>Email</h4>
                        <p>info@ur2ndlot.com</p>
                      </div>
                    </div>

                  </div>

                  <div className="col-lg-6 mt-5 mt-lg-0 d-flex align-items-stretch contactfoms">
                    <form onSubmit={handleSubmit(EmailSubmit)} method="post" role="form" className="php-email-form">
                      <h3>Enquiry Form</h3>

                      <div className="form-group">
                        <label htmlFor="name">Full Name</label>
                        <input type="text" name="name" className="form-control" id="name" value={name}
                          onChange={(e) => setName(e.target.value)} />

                        <p className="form-input-error" >{fullNameError}</p>
                        <div className="validate"></div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="name">Email</label>
                        <input type="text" className="form-control" name="email" id="email" value={email}
                          onChange={(e) => setEmailId(e.target.value)} />

                        <p className="form-input-error" >{emailError}</p>
                        <div className="validate"></div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="name">Comments</label>
                        <textarea className="form-control" name="message" rows="3" value={comments}
                          onChange={(e) => setComments(e.target.value)}
                        ></textarea>

                        <p className="form-input-error" >{commentsError}</p>
                        <div className="validate"></div>
                      </div>

                      <div className="text-center">
                        <button className="cta-btn">Submit</button>
                      </div>
                    </form>
                  </div>

                </div>

              </div>
            </div>
          </div>}

        <section id="playstoreBlock" className="playstoreBlock">
          <div className="container">
            <div className="row content">
              <div className="col-lg-12 playstore-btn">
                <img src={appstore} />
                <img src={googleplay} />
              </div>
            </div>
          </div>
        </section>

        {isOpen && (
          <Modal show={isOpen} onHide={handleModalClose} centered>
            <Modal.Header /* closeButton */ className="contactus-head">
              <h2 className='enquiry' >{popupTitle}</h2>
            </Modal.Header>
            <Modal.Body>
              <div className="location-login">
                <img className={'successImg'} alt="" src={checkImg} />
              </div>
              <div className="CommonModalbody">
                {popupTitle !== "" && <h2>{popupTitle}</h2>}
                <p>{popupMsg}</p>
              </div>
            </Modal.Body>
            <Modal.Footer className='Contactus-ok'>
              {popupActionType.toLowerCase() === 'close' && (
                <Button variant="primary Contactus-btn " onClick={handleModalClose}>
                  OK
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        )}
      </main>
    </div>
  );
};


export default DashBoardContactus